var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_market") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ui-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ASSETS",
    transform: "translate(-264, -40)",
    fill: "#324149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_market",
    transform: "translate(264, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.778,0.889 C3.778,0.398 3.38,0 2.889,0 C2.398,0 2,0.398 2,0.889 L2,15.111 C2,15.602 2.398,16 2.889,16 C3.38,16 3.778,15.602 3.778,15.111 L3.778,9.189 C3.865,9.154 3.958,9.116 4.056,9.078 C4.57,8.879 5.163,8.682 5.615,8.615 C6.366,8.504 6.944,8.72 7.695,9.017 L7.733,9.032 C8.46,9.32 9.355,9.674 10.504,9.504 C11.523,9.353 12.862,8.765 13.213,8.606 C13.536,8.46 13.734,8.141 13.734,7.798 L13.734,2.236 C13.734,1.582 13.062,1.165 12.482,1.419 C11.991,1.634 10.994,2.038 10.296,2.141 C9.546,2.252 8.968,2.035 8.217,1.739 L8.178,1.723 C7.451,1.436 6.556,1.082 5.407,1.252 C4.877,1.331 4.274,1.524 3.778,1.707 L3.778,0.889 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarket);
export default __webpack_public_path__ + "static/media/ic_market.b90eb6b6f99ded08ce00755589ebe7d0.svg";
export { ForwardRef as ReactComponent };